import React, { FC } from 'react';
import styles from './sub_header_action_slider.module.scss';

type Props = {
  isVisible: boolean;
};

export const SubHeaderActionSlider: FC<Props> = ({ isVisible, children }) => {
  return (
    <div className={styles.tunnel}>
      <div className={isVisible ? styles.slider : styles.move}>{children}</div>
    </div>
  );
};

export const SubHeaderSlide: FC = ({ children }) => {
  return <div className={styles.slide}>{children}</div>;
};
